export function clickableCard() {

    //make entire card clickable
    $(".post-card").on("click", function (e) {
        if (e.target.className !== 'category-link') {
            if ($(this).find(".post-link").attr("href")) {
                window.location = $(this).find(".post-link").attr("href");
                return false;
            } else {
                window.location = $(this).find("a").attr("href");
                return false;
            }
        }
    });
}

export function sortCards() {
    $('.sort-items').on('change', function (e) {
        let baseUrl = window.location.origin;
        let pathName = window.location.pathname;
        let url = new URL(`${baseUrl}${pathName}`);

        let valueSelected = this.value;
        if (valueSelected !== 'undefined' && valueSelected !== "") {
            url.searchParams.append('sort', valueSelected);
        }
        window.location = url.href;
    });
}